import React from 'react';
import { Title } from 'react-native-paper';
import { Trans } from '@lingui/macro';

import Divider from '@src/components/Divider';
import PrimeBookCard from '@src/components/PrimeBookCard';
import Separator from '@src/components/Separator';
import { PrimeBook } from '@src/types';

import { ContentWrapper } from './styled';

type Props = {
  data?: PrimeBook[];
  isImmigration?: boolean;
};

const Primes: React.FC<Props> = ({ data, isImmigration }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <ContentWrapper>
      <Separator />
      <Divider />
      <Separator />
      {/* <Title>
        <Trans>Collection youtopins</Trans>
      </Title> */}
      {data.map((item) => (
        <PrimeBookCard
          key={item.id}
          item={item}
          isImmigration={isImmigration}
        />
      ))}
    </ContentWrapper>
  );
};

export default React.memo(Primes);
